import React from 'react';
import './managerNavigation.css';

export type ManagerViewId = 'dashboard' | 'shortages' | 'counts' | 'purchasing' | 'vendors' | 'library' | 'recipes' | 'menu' | 'reports' | 'operations' | 'labor' | 'users' | 'activity' | 'integrations';
export type ManagerSectionId = Exclude<ManagerViewId, 'reports' | 'users' | 'activity' | 'integrations'> | 'settings';
export type ManagerNavEntry = [ManagerViewId, React.ReactNode, string];
export type ManagerSidebarEntry = [ManagerSectionId, React.ReactNode, string];

export function managerSectionFor(view: ManagerViewId): ManagerSectionId {
  if (view === 'users' || view === 'activity' || view === 'integrations') return 'settings';
  return view === 'reports' ? 'dashboard' : view;
}

/** Group only already-authorized views. This function never grants module access. */
export function compactManagerNavigation(views: ManagerNavEntry[], settingsIcon: React.ReactNode, settingsLabel: string): ManagerSidebarEntry[] {
  const dashboard = views.find(([id]) => managerSectionFor(id) === 'dashboard');
  const sections: ManagerSidebarEntry[] = views.filter(([id]) => !['dashboard', 'settings'].includes(managerSectionFor(id))).map(([id, icon, label]) => [managerSectionFor(id), icon, label]);
  if (dashboard) sections.unshift(['dashboard', dashboard[1], 'Dashboard']);
  if (views.some(([id]) => managerSectionFor(id) === 'settings')) sections.push(['settings', settingsIcon, settingsLabel]);
  return sections;
}

export function ManagerSectionNavigation({ entries, activeView, label, onSelect }: { entries: ManagerNavEntry[]; activeView: ManagerViewId; label: string; onSelect: (id: ManagerViewId) => void }) {
  if (entries.length < 2) return null;
  return <nav className="manager-section-navigation" aria-label={label}>{entries.map(([id, icon, text]) => <button type="button" key={id} className={id === activeView ? 'active' : ''} aria-current={id === activeView ? 'page' : undefined} onClick={() => onSelect(id)}>{icon}<span>{text}</span></button>)}</nav>;
}
